<template>
	<transition name="slide-sidebar">
		<div
			class="sidebar-filter"
			v-if="visible"
			@keyup.enter="ApplyFilters"
		>
			<div class="sidebar-body">
				<div class="w-full py-2 justify-content-center">
					<div class="w-full d-flex justify-center items-center mb-4">
						<div class="btn-group-checkbox">
							<label
								v-for="(weekday, index) in weekdays"
								:key="index"
								:for="weekday.initials"
							>
								<input
									type="checkbox"
									v-model="localFilters.weekdays"
									:value="weekday.value"
									:id="weekday.initials"
								/>
								<div
									class="btn p-3"
									:class="{
										'is-selected': !isNotChecked(
											weekday.value
										),
									}"
								>
									{{ weekday.initials.toUpperCase() }}
								</div>
							</label>
						</div>
					</div>

					<div class="w-full">
						<div
							class="dropdown d-block position-relative"
							:class="{ 'has-filters-dot': HasPeriodFilter() }"
						>
							<button
								class="btn btn-light btn-block"
								@click="ToggleDropdown('period')"
							>
								<i class="far fa-chevron-down font-14 mr-3"></i>
								PERÍODO
							</button>
							<div
								v-if="openDropdowns.period"
								class="dropdown-menu px-3 py-0 show"
							>
								<form>
									<div
										class="form-check my-3"
										:class="{
											'text-muted':
												IsNotVisuallyChecked(1),
										}"
									>
										<input
											id="manha"
											v-model="visualPeriods"
											type="checkbox"
											class=""
											:value="1"
											@change="TogglePeriod(1)"
										/>
										<label
											class="form-check-label"
											for="manha"
										>
										</label>
										<span
											class="flex-1 text-uppercase text-ellipsis ml-3"
											@click.stop.prevent="
												toggleItem(1, visualPeriods)
											"
										>
											MANHÃ (6h - 11h)
										</span>
									</div>
									<div
										class="form-check my-3"
										:class="{
											'text-muted':
												IsNotVisuallyChecked(2),
										}"
									>
										<input
											id="tarde"
											v-model="visualPeriods"
											type="checkbox"
											:value="2"
											@change="TogglePeriod(2)"
										/>
										<label
											class="form-check-label"
											for="tarde"
										>
										</label>
										<span
											class="flex-1 text-uppercase text-ellipsis ml-3"
											@click.stop.prevent="
												toggleItem(2, visualPeriods)
											"
										>
											TARDE (12h - 18h)
										</span>
									</div>
									<div
										class="form-check my-3"
										:class="{
											'text-muted':
												IsNotVisuallyChecked(3),
										}"
									>
										<input
											id="noite"
											v-model="visualPeriods"
											:value="3"
											type="checkbox"
											@change="TogglePeriod(3)"
										/>
										<label
											class="form-check-label"
											for="noite"
										>
										</label>
										<span
											class="flex-1 text-uppercase text-ellipsis ml-3"
											@click.stop.prevent="
												toggleItem(3, visualPeriods)
											"
										>
											NOITE (19h - 5h)
										</span>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div class="w-full mt-3">
						<div
							class="dropdown d-block mt-3 position-relative"
							:class="{ 'has-filters-dot': HasDateFilter() }"
						>
							<button
								class="btn btn-light btn-block"
								@click="ToggleDropdown('date')"
							>
								<i class="far fa-chevron-down font-14 mr-3"></i>
								DATA
							</button>
							<div
								v-if="openDropdowns.date"
								class="dropdown-menu px-3 py-0 show"
							>
								<div class="form-group my-3">
									<label class="font-14 mb-1">DE</label>
									<input
										v-mask="'##/##/####'"
										type="text"
										class="form-control p-3"
										placeholder="DD/MM/AAAA"
										:value="dateInputs.date_init"
										@input="
											ManualDateInput($event, 'date_init')
										"
										@blur="SyncManualDateInput('date_init')"
									/>
								</div>
								<div class="form-group my-3">
									<label class="font-14 mb-1">ATÉ</label>
									<input
										v-mask="'##/##/####'"
										type="text"
										class="form-control p-3"
										placeholder="DD/MM/AAAA"
										:value="dateInputs.date_end"
										@input="
											ManualDateInput($event, 'date_end')
										"
										@blur="SyncManualDateInput('date_end')"
									/>
								</div>
								<div class="form-group my-3 position-relative">
									<label class="font-14 mb-1">PERÍODO</label>
									<div class="input-with-icon">
										<flatpickr
											v-model="dateRange"
											:config="datePickerConfig"
											class="p-3 w-100"
											placeholder="SELECIONE O INTERVALO"
										/>
										<i
											class="icon-calendar far fa-calendar-alt"
										></i>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="w-full mt-3">
						<div
							class="dropdown d-block mt-3 position-relative"
							:class="{ 'has-filters-dot': HasAgendaFilter() }"
						>
							<button
								class="btn btn-light btn-block"
								@click="ToggleDropdown('schedules')"
							>
								<i class="far fa-chevron-down font-14 mr-3"></i>
								AGENDAS UTILIZADAS
							</button>
							<div
								v-if="openDropdowns.schedules"
								class="dropdown-menu px-3 py-0 show schedule-scroll"
							>
								<form>
									<div
										v-for="(schedule, index) in schedules"
										:key="index"
										class="form-check my-3 text-muted"
									>
										<input
											:id="schedule.nome + index"
											v-model="localFilters.schedules"
											:value="schedule"
											type="checkbox"
										/>
										<label
											:for="schedule.nome + index"
											class="form-check-label"
										>
										</label>
										<span
											class="flex-1 text-uppercase text-ellipsis ml-3"
											@click.stop.prevent="
												toggleItem(
													schedule,
													localFilters.schedules
												)
											"
										>
											{{ schedule.nome }}
										</span>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import Flatpickr from 'vue-flatpickr-component'
	import 'flatpickr/dist/flatpickr.css'
	import { Portuguese } from 'flatpickr/dist/l10n/pt.js'

	import moment from 'moment'

	export default {
		name: 'FiltersSideBar',
		components: {
			Flatpickr,
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			filters: {
				type: Object,
				required: true,
			},
			schedules: {
				type: Array,
				default: () => [],
			},
			weekdays: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				dateRange: [],
				datePickerConfig: {
					mode: 'range',
					dateFormat: 'Y-m-d',
					locale: Portuguese,
					altInput: true,
					altFormat: 'd/m/Y',
					wrap: true,
					onClose: this.handleDateRangeChange,
					onReady(selectedDates, dateStr, instance) {
						if (
							!instance.calendarContainer.querySelector(
								'.flatpickr-clear'
							)
						) {
							const clearBtn = document.createElement('button')
							clearBtn.textContent = 'Limpar'
							clearBtn.type = 'button'
							clearBtn.className =
								'flatpickr-clear btn btn-sm btn-light mt-1'
							clearBtn.onclick = function () {
								instance.clear()
								instance.close()
							}

							instance.calendarContainer
								.querySelector('.flatpickr-footer')
								?.appendChild(clearBtn) ||
								instance.calendarContainer.appendChild(clearBtn)
						}
					},
				},
				localFilters: {
					...this.GetFiltersPayload(this.filters),
				},
				dateInputs: {
					date_init: this.FormatDateInput(this.filters.date_init),
					date_end: this.FormatDateInput(this.filters.date_end),
				},
				visualPeriods: [],
				periodEdited: false,
				openDropdowns: {
					period: true,
					date: true,
					schedules: true,
				},
			}
		},
		watch: {
			filters: {
				handler(newVal) {
					const normalizedFilters = this.GetFiltersPayload(newVal)

					this.localFilters = normalizedFilters
					this.SyncDateInputs(normalizedFilters)
					this.SyncPeriodState(normalizedFilters)
				},
				deep: true,
				immediate: true,
			},
			localFilters: {
				handler(newVal) {
					this.$emit(
						'filters-changed',
						this.GetFiltersPayload(newVal)
					)
				},
				deep: true,
			},
			dateRange(val) {
				if (val) {
					const [start, end] = val.split(' até ')
					this.localFilters.date_init = start || ''
					this.localFilters.date_end = end || ''
				} else {
					this.localFilters.date_init = ''
					this.localFilters.date_end = ''
				}

				this.SyncDateInputs(this.localFilters)
			},
		},
		methods: {
			GetFiltersPayload(filters = this.localFilters) {
				return {
					weekdays: [...(filters.weekdays ?? [])],
					period: [...(filters.period ?? [1, 2, 3])],
					date_init: filters.date_init ?? '',
					date_end: filters.date_end ?? '',
					schedules: [...(filters.schedules ?? [])],
				}
			},
			SyncPeriodState(filters = this.localFilters) {
				const period = [...(filters.period ?? [1, 2, 3])]

				this.periodEdited = period.length !== 3
				this.visualPeriods = this.periodEdited ? period : []
			},
			SyncDateInputs(filters = this.localFilters) {
				this.dateInputs = {
					date_init: this.FormatDateInput(filters.date_init),
					date_end: this.FormatDateInput(filters.date_end),
				}
			},
			CloseSideBar() {
				this.$emit('close')
			},
			isNotChecked(value) {
				return this.localFilters.weekdays.indexOf(value) === -1
			},
			IsNotVisuallyChecked(value) {
				return !this.visualPeriods.includes(value)
			},
			TogglePeriod(value) {
				this.periodEdited = true

				if (!this.visualPeriods.includes(value)) {
					this.localFilters.period = this.localFilters.period.filter(
						p => p !== value
					)
				} else {
					if (
						this.localFilters.period.length === 3 &&
						this.visualPeriods.length === 1
					) {
						this.localFilters.period = [value]
					} else if (!this.localFilters.period.includes(value)) {
						this.localFilters.period.push(value)
					}
				}

				if (this.visualPeriods.length === 0) {
					this.periodEdited = false
					this.localFilters.period = [1, 2, 3]
				}
			},
			ApplyFilters() {
				this.$emit('apply-filters', this.GetFiltersPayload())
			},
			FormatDateInput(value) {
				return value ? moment(value).format('DD/MM/YYYY') : ''
			},
			ParseDateInput(value) {
				const parsed = moment(value, 'DD/MM/YYYY', true)
				return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
			},
			ManualDateInput(event, field) {
				const inputValue = event.target.value

				this.dateInputs[field] = inputValue

				if (inputValue === '') {
					this.localFilters[field] = ''
					return
				}

				if (inputValue.length < 10) {
					return
				}

				const parsedDate = this.ParseDateInput(inputValue)

				if (parsedDate) {
					this.localFilters[field] = parsedDate
				}
			},
			SyncManualDateInput(field) {
				const inputValue = this.dateInputs[field]

				if (inputValue === '') {
					this.localFilters[field] = ''
					return
				}

				const parsedDate = this.ParseDateInput(inputValue)

				if (parsedDate) {
					this.localFilters[field] = parsedDate
					this.dateInputs[field] = this.FormatDateInput(parsedDate)
					return
				}

				this.dateInputs[field] = this.FormatDateInput(
					this.localFilters[field]
				)
			},
			ToggleDropdown(key) {
				this.openDropdowns[key] = !this.openDropdowns[key]
			},
			HasPeriodFilter() {
				return this.periodEdited === true
			},
			HasDateFilter() {
				return (
					this.localFilters.date_init !== '' ||
					this.localFilters.date_end !== ''
				)
			},
			HasAgendaFilter() {
				return this.localFilters.schedules.length > 0
			},
			ClearFilters() {
				this.localFilters = this.GetFiltersPayload({
					weekdays: [],
					period: [1, 2, 3],
					date_init: '',
					date_end: '',
					schedules: [],
				})

				this.visualPeriods = []
				this.periodEdited = false
				this.SyncDateInputs(this.localFilters)
			},
			toggleItem(item, list) {
				const index = list.indexOf(item)
				if (index === -1) {
					list.push(item)
				} else {
					list.splice(index, 1)
				}
			},
		},
	}
</script>

<style lang="css" scoped>
	.btn.is-selected {
		background-color: var(--newPrimaryActiveBackgroundColor) !important;
		border-color: var(--newPrimaryActiveBackgroundColor) !important;
		color: var(--newPrimaryActiveColor) !important;
	}

	.sidebar-filter {
		display: flex;
		flex-direction: column;
	}

	.sidebar-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px;
	}

	.sidebar-body {
		flex: 1;
		padding: 5px;
	}

	.sidebar-footer {
		padding: 10px 13px;
		display: flex;
		justify-content: space-between;
	}

	.dropdown-menu {
		display: block;
		position: static !important;
		inset: auto !important;
		transform: none !important;
		float: none;
		z-index: auto;
		width: 100%;
		margin-top: 0.5rem;
		background: transparent !important;
	}

	.schedule-scroll {
		max-height: 150px;
		overflow-y: auto;
	}

	.has-filters-dot::after {
		content: '';
		background-color: #e0dd2e;
		width: 12px;
		height: 12px;
		border: solid 1px #e0dd2e;
		border-radius: 50%;
		z-index: 9;
		right: -5px;
		top: -5px;
		position: absolute;
	}

	.slide-sidebar-enter-active,
	.slide-sidebar-leave-active {
		transition: transform 0.3s ease-in;
	}

	.slide-sidebar-enter-from,
	.slide-sidebar-leave-to {
		transform: translateX(-100%);
	}

	.slide-sidebar-enter-to,
	.slide-sidebar-leave-from {
		transform: translateX(0);
	}

	::v-deep .flatpickr-calendar {
		font-size: 16px !important;
		scale: 0.77 !important;
		transform-origin: top left !important;
	}

	:global(
			.flatpickr-current-month
				.flatpickr-monthDropdown-months
				.flatpickr-monthDropdown-month
		) {
		font-size: 12px !important;
	}

	.input-with-icon {
		position: relative;
	}

	.input-with-icon .icon-calendar {
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
		font-size: 14px;
		pointer-events: none;
	}
</style>
